module.exports = __webpack_public_path__ + "img/setmeal.e721cb05.svg";